var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"PageFooter"},[_c('p',{staticClass:"mb-0 copyright"},[_vm._v("©2020 — Swyft Sites"),_c('sup',[_vm._v("®")])])])}
var staticRenderFns = []

export { render, staticRenderFns }